module.exports = __webpack_public_path__ + "static/img/12areaB_09.8494f54.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_09.png
// module id = 1101
// module chunks = 1